import React, { createContext, useContext } from "react";

interface PredictionsSearchContextProps {
  searchValue: string;
}

const PredictionsSearchContext = createContext<PredictionsSearchContextProps>({
  searchValue: "",
});

const PredictionsSearchProvider = ({
  children,
  value,
}: {
  children: React.ReactNode;
  value: string;
}) => {
  return (
    <PredictionsSearchContext.Provider value={{ searchValue: value }}>
      {children}
    </PredictionsSearchContext.Provider>
  );
};

const usePredictionsSearchContext = (): PredictionsSearchContextProps => {
  const context = useContext(PredictionsSearchContext);
  if (!context) {
    throw new Error(
      "usePredictionsSearchContext must be used within a PredictionsSearchProvider",
    );
  }
  return context;
};

export { PredictionsSearchProvider, usePredictionsSearchContext };
